export default {
  "brand.name": "Basetao Spreadsheet",
  "nav.home": "Startseite",
  "nav.guide": "Einkaufsführer",
  "nav.review": "Bewertung",
  "nav.shipping": "Versand",
  "nav.qc": "QC",
  "nav.articles": "Artikel",
  "cta.explore": "Basetao Spreadsheet entdecken",
  "cta.buyNow": "Jetzt kaufen",
  "cta.brand": "Basetao Spreadsheet",
  "cta.readGuide": "Den vollständigen Leitfaden lesen",
  "cta.backHome": "Zurück zur Startseite",
  "cta.visitMain": "Unsere Hauptwebsite besuchen",
  "footer.tagline": "Unabhängige Ressourcen, Leitfäden und Produktrecherche-Tools zu Basetao Spreadsheet.",
  "footer.disclaimer": "Dies ist eine unabhängige Informationsquelle. Informationen können sich ändern und sollten unabhängig überprüft werden. Wir sind mit keinem genannten Drittanbieter verbunden, von ihm unterstützt oder mit ihm verknüpft.",
  "footer.rights": "Alle Rechte vorbehalten.",
  "footer.resources": "Ressourcen",
  "footer.legal": "Rechtliches",
  "lang.en": "English",
  "lang.fr": "Français",
  "lang.de": "Deutsch",
  "lang.es": "Español",
  "lang.pt": "Português",
};